export default __webpack_public_path__ + "static/media/empoty-file.d1515cbd.svg";